import { experiment } from "@faire/web--source/common/settings/declarations/experiment";
/**
 * Controls whether client side performance optimizations are enabled on the Filter Section.
 */ export var FE_MILLION_LINT_FILTERS_OPTIMIZATION_250127 = experiment({
    name: "FE_MILLION_LINT_FILTERS_OPTIMIZATION_250127",
    identifier: "RetailerTokenOrLoggedOutSessionToken",
    client: "RETAILER",
    notifyAfter: "2025-05-07",
    productArea: "SEARCH",
    defaultValue: false
});
